import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import Fetch from "../../../utils/fetch";

export interface IReservation {
  id: number;
  guest_name: string;
  property_name: string;
  check_in: string;
  check_out: string;
  checkin_time: string;
  number_of_nights: number;
  rooms: number;
  reservation_status: string;
  grand_total_rate: number;
  total_paid_amount: number;
  is_invoice_closed: boolean;
  property_tracking_id: string;
  ota_tracking_id: string;
  created_at: Date;
  payment_status: string;
  receive_currency: string;
  receive_amount: string;
  is_cancelable: boolean;
}

interface IFetchData {
  count: {
    count: string;
  }[];
  reservations: IReservation[];
}

export interface IReservationsParams {
  date_type: string;
  from_date: Date | null;
  to_date: Date | null;
  property_id: string;
  reservation_id: string;
  reservation_status: string;
  guest_name: string;
  guest_email: string;
  guest_mobile_no: string;
  ota_tracking_id: string;
  offset: number;
  pageSize: number;
}

export default function useReservations(params: IReservationsParams) {
  const navigate = useNavigate();

  return useQuery(
    [{ scope: "reservations", params }],
    async ({ queryKey: [{ params }] }) =>
      await Fetch<IFetchData>({
        method: "POST",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/b2b/booking/property/reservations`,
        body: params,
        navigate,
      }),
    { keepPreviousData: true }
  );
}
